import DevLog from '../devlog/Module'
import { ModuleID } from '../types'
import {
  IActionHook,
  IExitHook,
  IInterceptHook,
  IHooksModule,
  IPostHook,
  IErrorHook,
  IErrorBody,
  IHapticHook,
  IRenderHook,
  IClosePreviewHook
} from './types'
import DoPostError from '../client/DoPostError'

let actionHook: IActionHook = null
let postHook: IPostHook = null
let exitHook: IExitHook = null
let interceptHook: IInterceptHook = null
let errorHook: IErrorHook = null
let renderHook: IRenderHook = null
let hapticHook: IHapticHook = null
let closePreviewHook: IClosePreviewHook = null
let moduleLoaded = false

const HooksModule: IHooksModule = {
  get id() {
    return ModuleID.HOOKS
  },
  config({ action, post, exit, error, render, haptic, intercept, closePreview } = {}) {
    if (renderHook && !render) renderHook(null)
    actionHook = action
    postHook = post
    interceptHook = intercept
    exitHook = exit
    errorHook = error
    renderHook = render
    hapticHook = haptic
    closePreviewHook = closePreview
    return HooksModule
  },
  async load() {
    moduleLoaded = true
    return Promise.resolve(HooksModule)
  },
  get loaded() {
    return moduleLoaded
  },

  // action hook
  get hasActionHook() {
    return null != actionHook
  },
  doAction(action) {
    if (HooksModule.hasActionHook) {
      try {
        return actionHook(action)
      } catch (error) {
        DevLog.moduleError(HooksModule, error, 'doAction', action)
      }
    }
    return action
  },

  // post hook
  get hasPostHook() {
    return null != postHook
  },
  async doPost(url, body, CSRFToken) {
    if (HooksModule.hasPostHook) {
      try {
        return await postHook(url, body, CSRFToken)
      } catch (error) {
        DevLog.moduleError(HooksModule, error, 'doPost', url, body)
        return null
      }
    }
    return null
  },

  // exit hook
  get hasExitHook() {
    return null != exitHook
  },
  doExit(hasFeedback?: boolean) {
    if (HooksModule.hasExitHook) {
      exitHook(hasFeedback)
    }
  },

  get hasClosePreviewHook() {
    return null != closePreviewHook
  },
  doClosePreview() {
    if (HooksModule.hasClosePreviewHook) {
      closePreviewHook()
    }
  },

  // render hook
  get hasRenderHook() {
    return null != renderHook
  },
  doRender(param: unknown) {
    if (HooksModule.hasRenderHook) {
      renderHook(param)
    }
  },

  // intercept hook
  get hasInterceptHook() {
    return null != interceptHook
  },
  async doIntercept(action) {
    if (HooksModule.hasInterceptHook) {
      return await interceptHook(action)
    }
    return null
  },

  // error hook
  get hasErrorHook() {
    return null != errorHook
  },
  async doError(error) {
    if (error instanceof DoPostError) {
      await error.response
        .json()
        .then((errorBody: IErrorBody) => (HooksModule.hasErrorHook ? errorHook(errorBody) : null))
    } else if (HooksModule.hasErrorHook)
      if (error instanceof Error)
        errorHook({
          text: error.message,
          errors: [{ code: 0, message: error.message, message_en: error.message, error: true }]
        })
      else
        errorHook({
          text: error as string,
          errors: [{ code: 0, message: error as string, message_en: error as string, error: true }]
        })
    return null
  },

  // haptic hook
  get hasHapticHook() {
    return null != hapticHook
  },
  haptic(type) {
    if (HooksModule.hasHapticHook) {
      hapticHook(type)
    }
  }
}

export default HooksModule
